import React from 'react';
import PropTypes from 'prop-types';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {
    isEmpty,
    extractWorkSheetData,
    getWithExpiry
} from "../../../globals/GlobalFunctions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import axios from 'axios';
import {refreshToken} from "../../../globals/GlobalFunctions";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

export interface Props {
    excelData: any;
    currentDB: string;
}

function BulkDivisionCopier({excelData, currentDB}: Props) {
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    const [validationText, setValidationText] = React.useState("");
    const [validationError, setValidationError] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [divisionCopy, setDivisionCopy] = React.useState({groupID: "",
        sourceDivisionID: "", destinationDivisionID: "", destinationDivisionName: "", vbasoftware_database: "CoastalAdminTest", vbapi_Token: ""});

    let token = localStorage.getItem('jwt');

    const handleValidationClose = () => {
        setValidationError(false);
        setValidationText("");
    }

    const initialCopyDivision = {
        groupID: "",
        sourceDivisionID: "",
        destinationDivisionID: "",
        destinationDivisionName: "",
        vbasoftware_database: "CoastalAdminTest",
        vbapi_Token: "",
    }

    const clearCopyDivision = () => {
        setDivisionCopy({...initialCopyDivision});
    }

    const importDivisionCopies = async (divisionCopyArray : any[]) => {
        refreshToken();
        setIsLoading(true);
        const response =
            await axios
                .post(
                    localStorage.getItem('baseURL') + 'Division/copyList',
                    divisionCopyArray,
                    {headers: {'Authorization': `Bearer ${token}`, accept: "*/*", "Content-Type": "application/json"}}
                ).then(() => {
                    setLoading(false);
                    setSuccessAlert(true);
                    setIsLoading(false);
                }).catch((error) => {
                    //console.log(response);
                    setLoading(false);
                    setValidationText(error.response.request.responseText);
                    setValidationError(true);
                    setIsLoading(false);
                });
        //console.log(response);
    }

    try {
        //Check for data and that there is a sheet in the data named IDCodeValue
        if (!isEmpty(excelData) && excelData.Sheets.DivisionCopy !== undefined) {
            //console.log(excelData, "Made it to formatter!");

            //global function to extract the data into a sequential array of cell data values as well as the column and row ranges
            let sheetDataArray = extractWorkSheetData(excelData.Sheets.DivisionCopy);

            let rawCellArray: any[] = sheetDataArray[0];

            let columnRange: number = sheetDataArray[1];

            let rowRange: number = sheetDataArray[2];

            let divisionArray: any[] = [];

            //console.log(rawCellArray, "Raw Data");

            //we need to find the column index of the values we require so we can grab the data for each row -- THIS IS WHERE COLUMN NAMES ARE SET
            //we add 1 for each for the loop multiplier to account for it being zero based, but later we subtract 1 to account for the very fist row actually starting at zero
            const divIndexCollection = {

                groupIndex: rawCellArray.indexOf('Group ID') + 1,
                originalDivisionIndex: rawCellArray.indexOf('Original Division ID') + 1,
                newDivisionIndex: rawCellArray.indexOf('New Division ID') + 1,
                newDivisionNameIndex: rawCellArray.indexOf('New Division Name') + 1,
            }

            if(divIndexCollection.groupIndex > 0 && divIndexCollection.originalDivisionIndex > 0 && divIndexCollection.newDivisionIndex > 0
                && divIndexCollection.newDivisionNameIndex > 0) {

                for (let i = 1; i < rowRange; i++) {
                    //for each new array we skip over the previous records determined by the column length, removing 1 to account for our zero based index at the beginning
                    let rowMultiplier = columnRange * i - 1;

                    //start with group
                    if (divIndexCollection.groupIndex > 0) {
                        divisionCopy.groupID = rawCellArray[(rowMultiplier + divIndexCollection.groupIndex)].toString();
                    }

                    //old division
                    if (divIndexCollection.originalDivisionIndex > 0) {
                        divisionCopy.sourceDivisionID = rawCellArray[(rowMultiplier + divIndexCollection.originalDivisionIndex)].toString().padStart(8, "0");
                    }

                    //new division
                    if (divIndexCollection.newDivisionIndex > 0) {
                        divisionCopy.destinationDivisionID = rawCellArray[(rowMultiplier + divIndexCollection.newDivisionIndex)].toString().padStart(8, "0");
                    }

                    //new division name
                    if (divIndexCollection.newDivisionNameIndex > 0) {
                        divisionCopy.destinationDivisionName = rawCellArray[(rowMultiplier + divIndexCollection.newDivisionNameIndex)].toString();
                    }

                    divisionCopy.vbasoftware_database = currentDB;

                    divisionCopy.vbapi_Token = getWithExpiry('vbapi_Token');

                    if(divisionCopy.groupID.length > 0 && divisionCopy.sourceDivisionID.length > 0
                        && divisionCopy.destinationDivisionID.length > 0 && divisionCopy.destinationDivisionName.length > 0) {
                        divisionArray.push({...divisionCopy});
                    }

                    divisionCopy.groupID = initialCopyDivision.groupID;
                    divisionCopy.sourceDivisionID = initialCopyDivision.sourceDivisionID;
                    divisionCopy.destinationDivisionID = initialCopyDivision.destinationDivisionID;
                    divisionCopy.destinationDivisionName = initialCopyDivision.destinationDivisionName;

                    clearCopyDivision();
                }

                importDivisionCopies(divisionArray);

                excelData.Sheets.DivisionCopy = undefined;
            }
            else {
                //setValidationText("Group ID, Plan ID, and Vendor are required.");
                //setValidationError(true);
            }

        }
    }
    catch(e) {
        console.log("ERROR", e);

        setErrorAlert(true);
        //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
        excelData.Sheets.DivisionCopy = undefined;
    }

    return (
        <div>
            {successAlert ? <Alert className="groupAlertStyles" severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                Bulk Division Copy Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert className="groupAlertStyles" severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
            <Dialog
                open={validationError}
                onClose={handleValidationClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Validation Error"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {validationText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleValidationClose}>OK</Button>
                </DialogActions>
            </Dialog>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}

export default React.memo(BulkDivisionCopier)

BulkDivisionCopier.propTypes = {
    excelData: PropTypes.object.isRequired
};
